"use strict";

var selectors = {
  searchInput: ".js-search-input",
  searchBtn: ".js-search-btn",
  dlrsList: ".js-dlrs-list",
  dlrsListContainer: ".js-dlrs-list-container",
  dlrItem: "#jsDlrItem",
  dlrItemClass: ".js-dlr-item",
  dlrsContainer: ".js-dlrs-container",
  dlrName: ".js-dlr-name",
  listMsg: ".js-list-message",
  searchMsg: ".js-search-message"
};

var dealerLocatorHome = function () {
  var map = void 0,
      geocoder = void 0,
      myJson = { instalaciones: [] },
      coords = [],
      ids = [],
      infos = [],
      bubbles = [],
      pts = [],
      markers = [],
      images = [],
      imagesOn = [],
      attempt = 0,
      market = void 0,
      staticServer = void 0;

  var _createGMap = function _createGMap(myJson, all) {
    var market = _getMarket();

    /* if (market === 'pt'){
      geocoder.geocode({ 'address': 'Portugal'}, function(results, status) {
        console.log('status', status)
        // if (status == google.maps.GeocoderStatus.OK) {
          map.setCenter(results[0].geometry.location)
          map.fitBounds(results[0].geometry.viewport)
        // }
      })
          console.log('geocoder', geocoder)
    } */

    var mapOptions = {
      zoom: 5,
      // center: new google.maps.LatLng(40, -3),
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      mapTypeControl: false,
      panControl: false,
      styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }]
    };

    if (market === "es") {
      mapOptions.center = new google.maps.LatLng(40, -3);
      staticServer = "https://estatico.nissan.es";
    }
    if (market === "pt") {
      mapOptions.center = new google.maps.LatLng(38, -8);
      staticServer = "https://estatico.nissan.pt";
    }

    map = new google.maps.Map(document.getElementById("google-map"), mapOptions);

    _showDealers(myJson, all);
  };

  var _loadGMAPI = function _loadGMAPI(myJson, all) {

    var market = _getMarket();
    var url = void 0;
    var iso3166_1 = function () {
      var result = void 0;
      switch (market) {
        case "es":
          result = "es-ES";
          break;
        case "pt":
          result = "pt-PT";
          break;
        default:
          result = "es-ES";
          break;
      }
      return result;
    }();

    // KEYS PARA PRODUCCIÓN
    var urlMaps = window.location.hostname === 'localhost' ?
    //  ? `https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false&libraries=places&language=${iso3166_1}&key=AIzaSyBbjzipLV9aXsivID8Qro2HkYi7lI4u7Uc`
    //  : `https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false&libraries=places&language=${iso3166_1}&key=AIzaSyBbjzipLV9aXsivID8Qro2HkYi7lI4u7Uc`

    //KEYS PARA DESARROLLO
    // let urlMaps = (window.location.hostname === 'localhost')
    "https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false&libraries=places&language=" + iso3166_1 + "&key=AIzaSyAshd6mpPWAmSWYmsRm5J3aUo-v-6u_KmM" : "https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false&libraries=places&language=" + iso3166_1 + "&key=AIzaSyAshd6mpPWAmSWYmsRm5J3aUo-v-6u_KmM";

    $.ajax({
      // Loading API
      url: urlMaps,
      dataType: "script",
      complete: function complete() {
        geocoder = new google.maps.Geocoder();
        _createGMap(myJson, all); // Initializing google map
      }
    });
  };

  var _searchDealerEvent = function _searchDealerEvent() {
    // Handling search dealer button event
    $(selectors.searchBtn).on("click", function (event) {
      event.preventDefault();
      if ($(selectors.searchInput).val().trim() !== "") {
        _searchPosition($(selectors.searchInput).val());
        attempt = 0;
      }
    });

    $(selectors.searchInput).on("keyup", function (ev) {
      if (ev.keyCode === 13 && $(this).val().trim() !== "") {
        _searchPosition($(this).val());
        $(this).trigger("blur");
      }
    });
  };

  var _getDealersJSON = function _getDealersJSON(value) {
    var market = _getMarket();
    var errorTxt = void 0;
    if (typeof market !== "undefined" && market.trim() !== "") {
      switch (market) {
        case "es":
          errorTxt = "No hay resultados para esta búsqueda.";
          break;

        case "pt":
          errorTxt = "Não foi encontrado nenhum valor.";
          break;

        default:
          errorTxt = "No hay resultados para esta búsqueda.";
          break;
      }
    } else {
      errorTxt = "No hay resultados para esta búsqueda.";
    }

    $.ajax({
      dataType: "script",
      url: "https://serviciosweb.nissan.es/dloc/localizador?value=" + encodeURIComponent(value),
      success: function success() {
        if (json.status === "OK") {
          _searchDealers(value, json.results[0].geometry.location.lat, json.results[0].geometry.location.lng);
        } else {
          // ZERO_RESULTS
          if (json.status === "ZERO_RESULTS") {
            _clearDealersList();
            _setSearchMsg(errorTxt);
          }

          // OVER_QUERY_LIMIT ---> Common message
          if (json.status === "OVER_QUERY_LIMIT") {
            if (attempt < 10) {
              _getDealersJSON(value);
              attempt++;
              console.log("Intento nº", attempt);
            } else {
              _clearDealersList();
              _setSearchMsg("Se ha producido un error. Inténtalo de nuevo un poco más tarde.");
              console.error("Se ha intentado " + attempt + " veces!!");
            }
          }
        }
      },
      error: function error() {
        _setSearchMsg("Se ha producido un error. Inténtalo de nuevo un poco más tarde.");
      }
    });
  };

  var _searchPosition = function _searchPosition(value) {
    if (typeof map !== 'undefined') _hideMarkers();
    _setSearchMsg('<p class="loader-img"><img src="img/loader.gif" alt="Buscando..."></p>');
    $(selectors.dlrsList).slideUp(); // Empty plants list
    _clearDealersList();
    _getDealersJSON(value);
  };

  var _searchDealers = function _searchDealers(value, lat, lng) {
    var requestType = $("#pvPeticion").val(),
        moi = $("#pvOferta").val();
    //   var input = document.querySelector('.search-input');
    //   var requestType = input.getAttribute('data-peticion-input');
    //   var moi = input.getAttribute('data-moi');
    var url = "https://serviciosweb.nissan.es/dloc/concesionario?pMode=busqueda&pvProvincia=" + encodeURIComponent(value) + "&vlatitud=" + lat + "&vlongitud=" + lng + "&pvPais=" + _getMarket() + "&pvTipoPeticion=stock";

    $.ajax({
      dataType: "script",
      url: url,
      success: function success() {
        myJson = json_concesiones;
        var all = value.trim() === "" ? true : false;
        _loadDealers(myJson, all);
      },
      error: function error() {
        _setSearchMsg("No se ha podido realizar la búsqueda.");
      }
    });
  };

  var _loadDealers = function _loadDealers(myJson, all) {
    // First call to load Dealers
    if (typeof map === 'undefined') {
      // $('#google-map').removeClass('hidden');
      // $('#first-google-map').addClass('hidden');
      _loadGMAPI(myJson, all);
    } else {
      _showDealers(myJson, all);
    }
  };

  var _showDealers = function _showDealers(myJson, all) {
    // Reset map variables
    coords = [];
    ids = [];
    infos = [];
    bubbles = [];
    pts = [];
    markers = [];
    images = [];
    imagesOn = [];

    var infotxt = "",
        misitems = myJson.instalaciones;

    _clearSearchMsg();

    // Iterates for each plant object received to generate the plants list again

    for (var i = 0; misitems[i]; i++) {
      var num = String(i + 1);
      num = num.length === 1 ? "0" + num : num;
      images[i] = "marker-off-" + num + ".png";
      imagesOn[i] = "marker-on-" + num + ".png";

      var itOrder = ["A", "B", "C", "D", "E", "F", "G", "H", "Y", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "AA", "AB", "AC", "AD", "AE", "AF", "AG", "AH", "AY", "AJ", "AK", "AL", "AM", "AN", "AO", "AP", "AQ", "AR", "AS", "AT", "AU", "AV", "AW", "AX", "AY", "AZ"];

      var _curInstalacion = misitems[i];
      ids[i] = _curInstalacion.id;
      coords[i] = [Number(_curInstalacion.latitud), Number(_curInstalacion.longitud), _curInstalacion.id];

      var buttonHtml = "<button type=\"button\" onclick=\"dealerLocator.concesSelected('" + _curInstalacion.id + "', '" + _curInstalacion.nombre + "')\" class=\" block left js-select-btn\" data-tracking-id=\"selectDealer\" data-tracking-label=\"\">SELECCIONAR</button>";

      var buttonLink = "<a class=\"bubble-link\" href=\"" + _curInstalacion.link + "/vehiculos-stock\" target=\"_blank\">SELECCIONAR</a>";

      infos[i] = "<div class=\"bubble js-dealer-item\" id=\"jsDlrItem\">\n                    <h4 class=\"js-it-name\">" + _curInstalacion.nombre + "</h4>\n                    <p class=\"js-it-address\">" + _curInstalacion.direccion + "</p>\n                    <p>" + _curInstalacion.cp + " " + _curInstalacion.poblacion + "</p>\n                    " + buttonLink + "\n                  </div>";
      // let $it = $(selectors.dlrItem)
      //   .clone()
      //   .removeAttr("id")
      //   .attr("id", `li-${curInstalacion.id}`);
      // $it
      //   .find(".js-it-order")
      //   .text(itOrder[i])
      //   .on("click", () => _showMarker(`${curInstalacion.id}`));
      // $it.find(".js-it-name").text(curInstalacion.nombre);
      // $it.find(".js-it-address").text(curInstalacion.direccion);
      // $it.find(".js-it-postalcode").text(curInstalacion.cp);
      // $it.find(".js-it-locality").text(curInstalacion.poblacion);
      // $it.find(".js-it-province").text(curInstalacion.provincia);
      // $it.find(".js-it-phone").text(curInstalacion.telefono);
      // $it

      // const selectDealerBtn = document.querySelector('.js-select-btn')

      // selectDealerBtn.addEventListener('click', function(event){
      //   event.preventDefault()
      //   console.log("hola función")

      //   const pvCodhostInput = document.querySelector("#pvCodhost")
      //   pvCodhostInput.addAttribute("value", curInstalacion.id)

      // })

      // .attr("data-tracking-label", curInstalacion.id);
      //$li.attr('id', `li-${curInstalacion.id}`).append($it)
      // $(selectors.dlrsList).append($it);
    }

    //ENVIAR INFO A INPUTS Y MOSTRAR FORMULARIO
    $(".js-select-btn").on("click", function () {

      var pvCodhostInput = document.querySelector("#pvCodhost");
      pvCodhostInput.addAttribute("value", curInstalacion.id);
    });

    $(selectors.dlrsList).slideDown();
    _createPointMarkerInfo(all);
    _placeMarkers();
    _adjustZoom();
  };

  var _hideMarkers = function _hideMarkers() {
    for (var i = 0; markers[i]; i++) {
      markers[i].setVisible(false);
      bubbles[i].close(map);
    }
  };

  var _clearDealersList = function _clearDealersList() {
    $(selectors.dlrsList).empty();
  };

  var _clearSearchMsg = function _clearSearchMsg() {
    $(selectors.listMsg).addClass("hidden");
    $(selectors.searchMsg).empty().addClass("hidden");
  };

  var _setSearchMsg = function _setSearchMsg(msg) {
    _clearSearchMsg();
    $(selectors.searchMsg).html(msg).removeClass("hidden");
  };

  // LatLng points, Markers & Bubbles

  var _createPointMarkerInfo = function _createPointMarkerInfo(all) {
    for (var i = 0; coords[i]; i++) {
      pts[i] = new google.maps.LatLng(coords[i][0], coords[i][1]);

      var markerimg = staticServer + "/commons/gmap-markers/" + images[i];
      var markerimgOn = staticServer + "/commons/gmap-markers/" + imagesOn[i];

      var ovalSVG = {
        path: "M14.999999999999993 0 C23.27872536741 0 29.999999999999986 6.721274632589998 29.999999999999986 14.999999999999979 C29.999999999999986 23.278725367409987 23.27872536741 29.999999999999957 14.999999999999993 29.999999999999957 C6.721274632590003 29.999999999999957 0 23.278725367409987 0 14.999999999999979 C0 6.721274632589998 6.721274632590003 0 14.999999999999993 0 Z",
        fillColor: "rgb(195, 0, 47)",
        fillOpacity: 1,
        strokeWeight: 0
      };

      markers[i] = new google.maps.Marker({
        position: pts[i],
        icon: markerimg,
        // icon: markerimg,
        iconOff: markerimg,
        iconOn: markerimgOn,
        code: coords[i][2]
      });

      bubbles[i] = new google.maps.InfoWindow({ maxHeight: 320 });
      bubbles[i].setContent(infos[i]);
      bubbles[i].setPosition(pts[i]);
      if (all) {
        geocoder.geocode({ address: "Spain" }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            map.setCenter(results[0].geometry.location);
            map.fitBounds(results[0].geometry.viewport);
            map.setZoom(map.getZoom() + 1);
          }
        });
      }
    }
  };

  var _placeMarkers = function _placeMarkers() {
    for (var k = 0; markers[k]; k++) {
      markers[k].setMap(map);
      bubbles[k].close(map);
      google.maps.event.addListener(markers[k], "click", function () {
        var n = $.inArray(this, markers);
        for (var i = 0; markers[i]; i++) {
          markers[i].setIcon(markers[i].iconOff);
          if (i != n) {
            bubbles[i].close(map);
          }
        }
        this.setIcon(this.iconOn);
        this.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
        bubbles[n].open(map, this);
        $(".bubble").parents('.gm-style-iw-d').attr("style", "overflow: hidden; padding: 14px"); //Solution for scroll infowindow bug
        // Mark item in list
        var myid = ids[n];
        var todositems = $(selectors.dlrItemClass);
        var item = $("#li-" + myid);
        if (!item.hasClass("redselected")) {
          todositems.removeClass("redselected");
          item.addClass("redselected");
        }
        $(selectors.dlrsListContainer).scrollTo(item);
      });
    }
  };

  var _adjustZoom = function _adjustZoom() {
    if (map) {
      if (pts.length > 1) {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < pts.length; i++) {
          bounds.extend(pts[i]);
        }
        map.fitBounds(bounds);
      } else {
        map.setCenter(pts[0]);
        map.setZoom(13);
      }
    }
  };

  var _showMarker = function _showMarker(id) {
    var todositems = $(selectors.dlrItemClass);
    var item = $("#li-" + id);
    if (!item.hasClass("redselected")) {
      todositems.removeClass("redselected");
      item.addClass("redselected");
    }
    for (var i = 0; i < markers.length; i++) {
      var curMarker = markers[i];
      if (curMarker.code == id) {
        curMarker.setIcon(staticServer + "/commons/gmap-markers/" + imagesOn[i]);
        bubbles[i].open(map, curMarker);
        var myPoint = new google.maps.LatLng(curMarker.position.lat(), curMarker.position.lng());
        map.panTo(myPoint);
        map.setZoom(12);
      } else {
        bubbles[i].close(map);
        curMarker.setIcon(staticServer + "/commons/gmap-markers/" + images[i]);
        $("#check-" + curMarker.code).removeAttr("checked");
      }
    }
  };

  var _concesSelected = function _concesSelected(concesion, nombreconcesion) {
    console.log("concesion", concesion, "nombreconcesion", nombreconcesion);
    $(".form-section").removeClass("hidden");
    var input = document.querySelector('.search-input');
    var tipoPeticion = input.getAttribute("data-peticion-input");
    var inputTipoPeticion = document.getElementById("pvPeticion");
    inputTipoPeticion.setAttribute("value", tipoPeticion);
    console.log();
    controlHostValue.setSelection(concesion, nombreconcesion);
  };

  // const _abreConces = () => {
  //   $('#nombreConces').text($('#nombreConces').attr('data-defecto'))
  //   $(selectors.dlrsContainer).slideDown('slow')
  // }

  var _setMarket = function _setMarket(str) {
    if (typeof str !== "undefined" && (str === "es" || str === "pt")) {
      market = str;
      return true;
    } else {
      console.error('dealerLocator.init() method requires an string parameter. It must be "es" or "pt"');
      return false;
    }
  };

  var _getMarket = function _getMarket() {
    return market;
  };
  var _init = function _init(market) {
    _loadGMAPI();
    if (_setMarket(market)) {
      _searchDealerEvent();
    }
  };

  var _reset = function _reset() {
    controlHostValue.reset();
    $(selectors.searchInput).val('');
    _createGMap();
    _clearDealersList();
  };

  return {
    init: _init,
    showMarker: _showMarker,
    concesSelected: _concesSelected,
    reset: _reset
  };
}();

var controlHostValue = function () {

  var txtConcesion = void 0,
      txtModificar = void 0;

  var _init = function _init(txtConc, txtModif) {
    txtConcesion = txtConc;
    txtModificar = txtModif;
  };

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  function _getTxtConc() {
    return txtConcesion;
  }

  function _getTxtModif() {
    return txtModificar;
  }

  function _setSelection(concesion, nombreconcesion) {

    $("#pvCodhost").val(concesion);
    $("*[name=pvCode]").val(concesion);
    // $('#errSel').remove();
    // $('#conceSel').remove();
    $(selectors.dlrName).html(" " + "<strong>" + nombreconcesion + "</strong> ");
    var botonModificar = $("<button/>").text("MODIFICAR").addClass("h-btn grey h-icon editpencil2 change-dealer-btn").on("click", function (event) {
      event.preventDefault();
      _abreConces();
    });
    $(selectors.dlrName).append(botonModificar);
    $(selectors.dlrsContainer).slideUp();
  }

  function _abreConces() {
    console.log("selectors.dlrName");
    $(selectors.dlrName).text($(selectors.dlrName).attr("data-defecto"));
    $(selectors.dlrsContainer).slideDown("slow");
  }

  function _reset() {
    _abreConces();
    $(selectors.dlrName).empty();
    $("#pvCodhost").val('');
    $("*[name=pvCode]").val('');
  }

  return {
    init: _init,
    setSelection: _setSelection,
    reset: _reset
  };
}();